import { VTooltip } from '../VTooltip';

export const ConditionalTooltip = ({
  children,
  toShowTooltip,
  content,
}: {
  children: React.ReactNode;
  toShowTooltip: boolean;
  content: React.ReactNode;
}) => {
  return toShowTooltip ? (
    <VTooltip content={content}>{children}</VTooltip>
  ) : (
    children
  );
};
